import { gql } from '@apollo/client'

const BASE_FIELDS = gql`
  fragment BaseAiTestTrainingDataFields on AiTestTrainingDataType {
    id
    question {
      id
      questionText
    }
    isFromAI
    userEmail
    quartile
    quartileExplanation
    responseFeedback
    answerText
    testType
    createdAt
  }
`

export const FIND_ALL_AI_TRAINING_DATA = gql`
  ${BASE_FIELDS}

  query findAllAiTestTrainingData($query: AiTestTrainingDataQueryInput!) {
    findAllAiTestTrainingData(query: $query) {
      items {
        ...BaseAiTestTrainingDataFields
      }
      count
    }
  }
`

export const SEARCH_AI_TEST_TRAINING_DATA = gql`
  ${BASE_FIELDS}

  query searchAiTestTrainingData($searchString: String) {
    searchAiTestTrainingData(searchString: $searchString) {
      items {
        ...BaseAiTestTrainingDataFields
      }
    }
  }
`

export const CREATE_AI_TEST_TRAINING_DATA = gql`
  mutation createAiTestTrainingData($input: CreateAiTestTrainingDataInput!) {
    createAiTestTrainingData(createAiTestTrainingDataInput: $input) {
      id
    }
  }
`

export const UPDATE_AI_TEST_TRAINING_DATA = gql`
  mutation updateAiTestTrainingData($input: UpdateAiTestTrainingDataInput!) {
    updateAiTestTrainingData(updateAiTestTrainingDataInputFieldName: $input) {
      id
    }
  }
`

export const REMOVE_AI_TEST_TRAINING_DATA = gql`
  mutation removeAiTestTrainingData($id: String!) {
    removeAiTestTrainingData(id: $id) {
      affected
    }
  }
`

export const EXPORT_TRAINING_DATA = gql`
  query exportTrainingData($ids: [String!]!, $isFromAi: Boolean!) {
    exportTrainingData(ids: $ids, isFromAI: $isFromAi)
  }
`
